import { gql } from "@apollo/client";

export const identifierFragment = gql`
  fragment IdentifierFragment on Identifier {
    value
    id
    identifierType {
      code
      name
    }
    schemaIdentifier {
      code
      name
    }
  }
`;
